<div class="note-draft-box" [ngStyle]="{ top: this.noteService.editorWindowTopPosition }">
    <app-new-note
        [ticketId]="ticket.id"
        [noteId]="noteService.commentedReply.id"
        [newNote]="noteService.newNoteModel"
        [isCancelAllowed]="true"
        [reply]="noteService.commentedReply"
        [isReplyNote]="true"
        (noteAdd)="onNoteAdd($event)"
        (closeNoteEditor)="onCloseEditor()"
        [isFocusNeeded]="true">
    </app-new-note>
</div>
